<template>
  <div>
    <Header></Header>

    <div class="row py-3 mb-4 justify-content-between pageTitleDiv">
      <div class="container pl-0">
          <div class="h1 mb-0 d-flex align-items-center font-lg pageTitle">
              {{$ml.get('COMPAINES')}}
              <span class="font-12 py-1 px-2 bg-new-badges border-radius-20  ml-2">{{totalCount}}</span>
          </div>
      </div>
    </div>
    <div class="container">
      <div class="row py-3 mb-4 justify-content-between pageTitleDiv2" >
        <div class="container pl-0">
            <div class="h1 mb-0 d-flex align-items-center font-lg pageTitle">
                {{$ml.get('COMPAINES')}}
                <span class="font-12 py-1 px-2 bg-new-badges border-radius-20  ml-2">{{totalCount}}</span>
            </div>
        </div>
      </div>
      <div class="row mb-2 justify-content-between filtreAndTableSetting">
        <div class="d-flex" v-if="windowWidth>maxMobilSize">
            
              <div class="float-left table-setting" v-if="$can('can_bulk_delete_organizations')">
                <button type="button" :title="$ml.get('BULK_ACTIONS')" class="btn btn-crm-secondary dropdown-toggle h40" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> 
                  <label class="p-0 m-0 btn-click">{{$ml.get('BULK_ACTIONS')}}</label>
                </button>
                <div class="dropdown-menu dropdown-menu-left dropMenu multiChoose p-0">
                    <ul class="new-dropdown p-0 border-0">
                        <li class=""  @click="openBulkUpdateModal()"><i class="fa fa-exchange h-14"></i> {{$ml.get('BULK_UPDATE')}}</li>
                        <li class="text-danger" @click="deleteSelectedRows()" v-if="$can('can_bulk_delete_organizations')"><i class="fa fa-trash h-14"></i> {{$ml.get('DELETE')}}</li>
                    </ul>
                </div>
            </div>

        </div>
        <div class="d-flex align-items-end">

          <div class="addBtn" data-toggle="modal" data-target="#add" @click="clearModal=false">
              <button type="button"  @click="activaTabOrganization()" class="btn bg-new-primary f-14 h-100">
                  <i class="fa fa-plus f-14 mr-2"></i> {{$ml.get('ADD_COMPANY')}}
              </button>   
          </div>

          <filterComponent class=" newFilterButton" @filter="filter=$event,getOrganizations('emitter')" :customFields="customFields" :users="this.users" :companyType="true" :status="true" :pageIs="pageIs"/>

            <div class="float-left ml-2 mr-2 table-setting">
                <button type="button" :title="$ml.get('SET_COLUMNS')" class="btn-crm-secondary btn btn-click p-2 dropdown-button h40 w40" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> 
                    <i class="fa fa-gear font-m"></i>
                </button>
                <div class="dropdown-menu dropdown-menu-right dropMenu multiChoose p-0">
                    <div class="p-2 mcBgDark">
                        <span class="text-white">{{selectedTableView.name}}</span>
                    </div>
                    <ul class="new-dropdown p-0 border-0">
                        <li class="p-0" v-for="col in gridColumns" v-show="(col['prop']!=='_id'&&col['prop']!=='x'&&col['prop']!=='notes'&&col['prop']!=='currency')">
                            <label class="w-100 custom-checkbox">
                                <input type="checkbox" :value="col['prop']" :disabled="tableConfigVisible.length <= 1 && tableConfigVisible.indexOf(col['prop']) != -1" v-model="tableConfigVisible"> 
                                <span class="label-text f-14">{{col['name']}}</span>
                            </label>
                        </li>
                    </ul>
                    <div class="dd-footer p-1">
                                <button type="button" data-toggle="modal"  data-target="#colListModal"  class="btn" style="background-color: #fff !important;color:#333333;border:1px solid #dcdddd">{{$ml.get('SAVED_VIEWS')}}</button>
                                <button type="button" @click="selectSaveMethod()" class="btn bg-new-primary" style="background-color:#1891eb !important"><i class="fa fa-save"></i> {{$ml.get('SAVE')}}</button>
                    </div>
                </div>
            </div>

            <div class="table-setting">
                  <button type="button" :title="$ml.get('SET_COLUMNS')" class="btn-crm-secondary btn btn-click p-2 dropdown-button h40 w40" data-toggle="dropdown"  aria-haspopup="true" aria-expanded="false"> 
                      <i class="fa fa-ellipsis-v font-m "></i>
                  </button>
                  <div class="dropdown-menu dropdown-menu-right dropMenu multiChoose p-0">
                      <ul class="new-dropdown p-0 border-0">
                          <li>
                              <a class="" @click="importFile" v-if="$can('can_use_import')">
                                  {{$ml.get('IMPORT_EXCEL')}}
                                     <i class="fas fa-file-import float-left pr-2" style="padding-top:11px;">
                                        <!-- <img src="../assets/xls-icon.png" width="23px"> -->
                                    </i>
                             </a>
                          </li>
                          <li>
                              <a class="" @click="exportOrganizationsF" v-if="$can('can_export_data_from_lists')">
                                  {{$ml.get('EXPORT_EXCEL')}}
                                  <i class="fas fa-file-export float-left pr-2" style="padding-top:11px;">
                                        <!-- <img src="../assets/xls-icon.png" width="23px"> -->
                                  </i>
                              </a>
                          </li>
                      </ul>
                  </div>
            </div>

        </div>

      </div>

      <div class="alert alert-secondary alert-dismissible fade show" v-if="totalCount == 0" role="alert">
        <strong>{{$ml.get('WARNING')}}</strong>
        {{$ml.get('NOT_FOUND_MESSAGE')}}
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <grid :data="gridData" v-if="windowWidth>maxMobilSize" @updateCheckedRows="updateCheckedRows($event)"  @editOrganization="getOrganizationData($event)" @sortedData="getSortedData($event)" :tableConfigVisible="tableConfigVisible" :columns="gridColumns" :cellUpdateUrl="organizationUpdate" :permissions="permissions" :user="user" :users="users" :filterGuide="guideCol" @scrolled="scrollfunctionOfGrid" :page="pageIs"></grid>
      <gridMobil :data="gridData" v-else @updateCheckedRows="updateCheckedRows($event)"  @editOrganization="getOrganizationData($event)" @sortedData="getSortedData($event)" :tableConfigVisible="tableConfigVisible" :columns="gridColumns" :cellUpdateUrl="organizationUpdate" :permissions="permissions" :user="user" :users="users" :filterGuide="guideCol" @scrolled="scrollfunctionOfGrid" :page="pageIs"></gridMobil>
      <div class="modal fade" id="add" ref="addmodal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:750px!important;">
          <div class="modal-content mcBgGrey crm-modal-content">
              <newOrganization ref="newOrganization" :isEditMode="false" :user="user" :users="users" :clearModal="clearModal" @updateList="getOrganizations('emitter')" :customFieldArray="customFields"></newOrganization>
          </div>
        </div>
      </div>
      <div class="modal fade in" id="addOrganizationModal" ref="editmodal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="addOrganizationModal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:750px!important">
            <div class="modal-content mcBgGrey crm-modal-content">
                <newOrganization ref="setData" :data="organizationData" :isEditMode="true" :user="user" :users="users" :clearModal="clearModal" @updateList="getOrganizations('emitter')" :customFieldArray="customFields"></newOrganization>
            </div>
        </div>
      </div>

      <div class="modal fade" id="importFile" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog mw-100 w-75" role="document">
            <div class="modal-content">
                  <takeImport :columns="gridColumns" :page="pageIs" @closeTakeModal="getOrganizations('emitter')"></takeImport>  
            </div>
          </div>
      </div>

      <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
      
      <!-- Toplu işlem Alan Değiştirme Modal Başlangıç -->
       <div class="modal fade "  id="bulkUpdate" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="bulkUpdateModal" aria-hidden="true">
                <div class="modal-dialog modal-xl modal-dialog-centered" role="document" >
                    <div class="modal-content mcBgGrey">
                        <div class="modal-header border-0 mt-2 pb-0 align-items-center">
                            <h5 class="modal-title font-weight-bold">{{$ml.get('BULK_FIELD_UPDATE')}}</h5>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12" v-for="(col,index) in bulkEditableColumns" v-bind:key="index">
                                    <div class="input-group mb-3">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">{{col.name}}</span>
                                        </div>
                                        <select class="custom-select" v-model="col.val">
                                            <option value="">{{$ml.get('SELECT')}}</option>
                                            <option :value="user._id.$oid" v-for="(user,ind) in users" v-bind:key="ind">{{user.name}} {{user.surName}}</option>
                                        </select>
                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <div class="col-12 dealBtnStyle p-0">
                                <button class="btn-new save" @click="updateOrganizationsF()">{{$ml.get('BULK_UPDATE_BTN_TXT')}}</button>
                                <button class="btn-new" data-dismiss="modal" aria-label="Close">
                                    {{$ml.get('CANCEL')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
      </div>

      <!-- Toplu işlem Alan Değiştirme Modal Bitiş  -->
      
      <div class="modal fade" id="colListModal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="collist" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content mcBgGrey">
                  <div class="modal-header border-0 mt-2 pb-0 align-items-center">
                            <h5 class="h5" id="saveColListModalTitle">{{$ml.get('SAVED_VIEWS')}}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" class="font-40">&times;</span>
                            </button>
                  </div>
                  <div class="modal-body">
                      <ul class="list-group radio-list-group" >
                          <li class="list-group-item">
                              <label for="" class="">
                                  <input type="radio" name="selectedview" v-model="selectedTableView" :value="defaultTableView"> {{$ml.get('DEFAULT_VIEW')}}
                              </label>
                          </li>
                          <li class="list-group-item" v-for="(view,index) in tableViewList"   v-bind:key="index">
                              <label for="" class="">
                                        <input type="radio" name="selectedview" v-model="selectedTableView" :value="view" > {{view.name}}
                              </label>
                              <i class="fa fa-trash text-danger" @click="deleteTableViewF(view._id.$oid)"></i>
                          </li>
                      </ul>
                  </div>
                  <div class="modal-footer">
                      <div class="col-12 dealBtnStyle p-0">
                          <button class="btn-new save" v-if="tableViewList.length>0"   @click="setTableViewF(selectedTableView._id.$oid)">
                                    {{$ml.get('APPLY')}}
                          </button>
                          <button class="btn-new" data-dismiss="modal" aria-label="Close">{{$ml.get('CANCEL')}}</button>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <div class="modal fade" id="selectMethodModal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="savecollist" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content mcBgGrey">
                    <div class="modal-header border-0 mt-2 pb-0 align-items-center">
                          <h5 class="h5" id="saveColListModalTitle">{{$ml.get('SAVE_VIEW')}}</h5>
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" class="font-40">&times;</span>
                          </button>
                    </div>
                    <div class="modal-body">
                          “{{selectedTableView.name}}” {{$ml.get('WHICH_WAY_TO_SAVE')}}
                    </div>
                    <div class="modal-footer">
                        <div class="col-12 dealBtnStyle p-0">
                              <button class="btn-new save mcBgDark" data-dismiss="modal" aria-label="Close" data-toggle="modal"  data-target="#saveTableViewModal" >
                                    {{$ml.get('SAVE_AS')}}
                              </button>
                              <button class="btn-new save" @click="updateTableViewF()">
                                    {{$ml.get('OVERWRITE')}}
                              </button>
                              <button class="btn-new" data-dismiss="modal" aria-label="Close">{{$ml.get('CANCEL')}}</button>
                        </div>
                    </div>
              </div>
          </div>
      </div>

      <div class="modal fade" id="saveTableViewModal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="savecollist" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content mcBgGrey">
                    <div class="modal-header border-0 mt-2 pb-0 align-items-center">
                        <h5 class="h5" id="saveColListModalTitle">{{$ml.get('SAVE_VIEW')}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true" class="font-40">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <label for="" class="">{{$ml.get('NAME_VIEW')}}</label>
                        <input type="text" class="form-control" v-model="newTableView.name">      
                    </div>
                    <div class="modal-footer">
                        <div class="col-12 dealBtnStyle p-0">
                            <button class="btn-new save" @click="saveTableViewF()">{{$ml.get('SAVE')}}</button>
                            <button class="btn-new" data-dismiss="modal" aria-label="Close">
                                {{$ml.get('CANCEL')}}
                            </button>
                        </div>
                    </div>
                </div>
          </div>
      </div>

    </div>
  </div>
</template>
<script>
import Header from './header'
import Grid from "./Grid";
import GridMobil from "./gridMobil";
import axios from "axios";
import newOrganization from "./newOrganization.vue";
import filterComponent from "./filterComponent.vue";
import takeImport from "./import.vue";
import Swal from 'sweetalert2'
import { mapState } from "vuex";
import { mapActions } from "vuex";
export default {
  components: {
    Header,
    Grid,
    GridMobil,
    newOrganization: newOrganization,
    filterComponent: filterComponent,
    takeImport:takeImport
  },
  name: "Organizations",
  data() {
    return {
      organizationsRaw:[],
      organizations: [],
      customFields: [],
      gridColumns: [
        { prop: "_id", name: "Id" },
        { prop: "cuid", name: this.$ml.get('HOLDER'), type:"user", default:false},
        { prop: "x", name: this.$ml.get('STATUS') },
        { prop: "status", name: this.$ml.get('STATUS'), type: "orgStatus" },
        { prop: "isCandidate", name: this.$ml.get('TYPE_COMPANY'), type: "candidate",default:true,valid:true },
        { prop: "name", name: this.$ml.get('COMPANY_NAME'), type: "orgName",default:true,valid:true  },
        { prop: "contacts", name: this.$ml.get('CONTACT_PERSONS'), type: "contacts",default:true,isSort:false },
        { prop: "createdAt", name: this.$ml.get('CREATION_DATE'), type: "dateObj" },
        { prop: "deals", name: this.$ml.get('OPPORTUNITIES'), type: "deals",isSort:false },
        { prop: "emailAddresses", name: this.$ml.get('E_MAILS'),type: "emailAddresses", default:true},
        { prop: "phoneNumbers", name: this.$ml.get('PHONE_NUMBERS'), type: "phones",default:true },
        { prop: "faxNumbers", name: this.$ml.get('FAKS_NUMBERS'), type: "phones" },
        { prop: "webAddr", name: this.$ml.get('WEB_SITES') },
        { prop: "addr", name: this.$ml.get('ADDRESS') },
        { prop: "country", name: this.$ml.get('COUNTRY'), type: "country" },
        { prop: "city", name: this.$ml.get('CITY'), type: "city",default:true },
        { prop: "town", name: this.$ml.get('DISTRICT'), type: "town" },
        { prop: "postalCode", name: this.$ml.get('POST_CODE') },
        { prop: "taxNo",name:this.$ml.get('TAX_NUMBER')},
        { prop: "taxOffice",name:this.$ml.get('TAX_ADMINISTRATION')}
      ],
      gridData: [],
      pagingSize: 30,
      pagingOffset: 0,
      totalCount: 0,
      bottom: false,
      organizationUpdate: "updateOrganization",
      guideCol: "name", // name column will be filtered by first letter
      user: [],
      users: [],
      filter: "",
      clearModal: false,
      pageIs: "organization",
      permissions: [],
      tableConfigVisible:[],
      filterDefault:"0",
      sort:null,
      sortType:null,
      organizationData:{},
      isEditMode:false,
      firstLoad:true,
      checkedRows:[],
      checkAllRows:false,
      exportLang:"",
      selectedTableView:{
                _id:{$oid:''}
      },
      defaultTableView:{
                name:this.$ml.get('DEFAULT_VIEW'),
                _id:{$oid:'default-view'}
      },
      tableViewList:[],
      newTableView:{
      },
      bulkEditableColumns: [
                { prop: "cuid", name: this.$ml.get('HOLDER'), val:"", type: "user" },//sahibi   
            ],
      gridColumnsImport: [
                { prop: "cuid", name: this.$ml.get('HOLDER'), type: "user",default:true }, 
            ],
    };
  },
  watch: {
    bottom(bottom) {
      if (bottom) {
        this.pagingOffset += this.pagingSize;
        this.getOrganizations();
      }
    },
    permissions: function() {
      if (this.permissions === undefined) {
        this.permissions = [];
      }
    },
    activePassiveStatus: function() {
      this.getOrganizations("emitter");
    }
  },
  methods: {
    updateCheckedRows(val){
        console.log("checked rows val")
        console.log(val)
        if(val=='allRowsChecked'){
            this.checkAllRows=true
            this.checkedRows = []
        }else{
            this.checkAllRows=false
            this.checkedRows = val
        }
    },
    deleteSelectedRows(){
      if(this.checkedRows.length==0&&this.checkAllRows==false){
          Swal.fire({
              title: this.$ml.get('WARNING'),
              text: this.$ml.get('NO_SELECTED_ROW_ON_DELETE'),
              icon: "warning"
          })
          return false
      }

      var form = {}
        if(this.checkAllRows==true&&this.filter==''){
          form.all = true
      }else if(this.checkedRows.length>0){
          form.organizationIds = this.checkedRows
      }
      
      if(this.filter!==''&&this.checkedRows.length==0){
          form.filter = this.filter
      }

      var confirm_message = this.$ml.get('DELETE_RECORDS_CONFIRM')
      if(this.$can('can_bulk_delete_organizations')&&this.$can('can_delete_other_users_organizations')){
          confirm_message = this.$ml.get('DELETE_RECORDS_CONFIRM')
      }else if(!this.$can('can_bulk_delete_organizations')&&this.$can('can_delete_other_users_organizations')){
          confirm_message = this.$ml.get('DELETE_RECORDS_CONFIRM_OTHERS')
      }else if(this.$can('can_bulk_delete_organizations')&&!this.$can('can_delete_other_users_organizations')){
          confirm_message = this.$ml.get('DELETE_RECORDS_CONFIRM_OWN')
      }

      Swal.fire({
          title: this.$ml.get('DELETE_RECORDS'),
          text: confirm_message,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: '#d33',
          confirmButtonText: this.$ml.get('DELETE_RECORDS_CONFIRM_BTN_TXT'),
          cancelButtonText: this.$ml.get('CANCEL'),
          customClass:{
              icon:'custom-delete-warning',
              cancelButton:'custom-delete-cancel-button'
          },
          reverseButtons:true
      }).then((result)=>{
          if(result.isConfirmed){
              this.deleteOrganizations(form).then((response)=>{
                  if(response.status.code=='0'){
                      this.$notify({ 
                          group: 'foo',
                          type: 'success', 
                          title: this.$ml.get('SUCCESSFUL'),
                          text: response.status.desc 
                      })
                      this.getOrganizations('emitter')
                  }else{
                      this.$notify({ 
                          group: 'foo',
                          type: 'error', 
                          title: this.$ml.get('ERROR'),
                          text: response.status.desc 
                      })
                  }
              })
          }
      })
    },
    getOrganizationData(orgId){
      this.isEditMode=true
      this.organizationData = this.organizationsRaw.find(item => item._id.$oid === orgId);
      $('#addOrganizationModal').modal('show')
    },
    getSortedData(form){
        this.sort=form.sort
        this.sortType=form.sortType
        this.getOrganizations('emitter')
    },
    exportOrganizationsF(){      
       ;
        axios({
            method:'POST',
            url:'/exportOrganizations',
            data:{
              language:this.exportLang
            },
            baseURL: this.baseUrl,
            withCredentials:true
        }).then((res)=>{
                return res
        }).then((res)=>{

             ;
            if(res.data.status.code==0 && res.data.content.link){
                window.open(res.data.content.link,'_blank')
            }else{
                this.$notify({ 
                    group: 'foo',
                    type: 'error', 
                    title: this.$ml.get('ERROR'),
                    text: res.data.status.desc 
                })
            }
        })
    },
    scrollfunctionOfGrid: function(
      scrollYEmit,
      clientHeightEmit,
      scrollHeightEmit
    ) {
      this.bottom = this.bottomVisible(
        scrollYEmit,
        clientHeightEmit,
        scrollHeightEmit
      );
    },
    bottomVisible(scrollYEmit, clientHeightEmit, scrollHeightEmit) {
      const scrollY = scrollYEmit;
      const visible = clientHeightEmit;
      const pageHeight = scrollHeightEmit;
      const bottomOfPage = visible + scrollY >= pageHeight;
      return bottomOfPage || pageHeight < visible;
    },
    updateList(event) {
      let obj = {};

      let productObj = event;
      let columns = this.gridColumns;

      for (var column in columns) {
        var colInProduct = productObj.hasOwnProperty(columns[column]["prop"]);

        if (colInProduct) {
          let edObj = {};

          edObj["val"] = productObj[columns[column]["prop"]];
          edObj["isEditMode"] = false;
          edObj["type"] = columns[column]["type"];

          obj[columns[column]["prop"]] = edObj;
        } else {
          let edObj = {};

          edObj["val"] = null;
          edObj["isEditMode"] = false;
          edObj["type"] = columns[column]["type"];
          obj[columns[column]["prop"]] = edObj;
        }
      }

      this.totalCount = this.totalCount + 1;
    },
    getOrganizations(emitter) {
      if(this.windowWidth<this.maxMobilSize){
          this.gridColumns= [
            { prop: "_id", name: "Id" },
            { prop: "cuid", name: this.$ml.get('HOLDER'), type:"user", default:false},
            { prop: "x", name: this.$ml.get('STATUS') },
            { prop: "status", name: this.$ml.get('STATUS'), type: "orgStatus" },
            { prop: "isCandidate", name: this.$ml.get('TYPE_COMPANY'), type: "candidate",default:true,valid:true },
            { prop: "name", name: this.$ml.get('COMPANY_NAME'), type: "orgName",default:true,valid:true  },
            { prop: "contacts", name: this.$ml.get('CONTACT_PERSONS'), type: "contacts",default:true,isSort:false },
            { prop: "emailAddresses", name: this.$ml.get('E_MAILS'),type: "emailAddresses", default:true},
            { prop: "phoneNumbers", name: this.$ml.get('PHONE_NUMBERS'), type: "phones",default:true },
            { prop: "city", name: this.$ml.get('CITY'), type: "city",default:true }
          ]
      }  

      if (emitter !== undefined) {
        this.pagingOffset = 0;
        if (screen.height > 720) {
          this.pagingSize = 30;
        } else {
          this.pagingSize = 20;
        }
      }
      var params = {}
      params.pagingSize=this.pagingSize
      params.pagingOffset=this.pagingOffset
      params.activePassiveStatus=this.activePassiveStatus
      params.filter=this.filter
      if(this.sort!=null){
          params.sort=this.sort
      }
      if(this.sortType!=null){
          params.sortType=this.sortType
      }
      axios({
        method: "POST",
        url: "/getOrganizations",
        baseURL: this.baseUrl,
        data: params,
        withCredentials: true
      })
        .then(res => {
          return res;
        })
        .then(res => {
          if (!res.data.status) {
            this.$router.push("/logout");
          }
          if (res.data.status.code == 0) {
            if (emitter !== undefined) {
              this.organizations = []
              this.organizationsRaw = []
            }
                this.totalCount = res.data.content.pageInfo["totalCount"];
            if (res.data.content.customFields) {
              for (var item in res.data.content.customFields) {
                let obj = {};

                obj["prop"] =
                  res.data.content.customFields[item]["_id"]["$oid"];
                obj["name"] = res.data.content.customFields[item]["name"];
                obj["type"] = res.data.content.customFields[item]["field_type"];
                if (res.data.content.customFields[item]["field_type"] == 4) {
                  obj["users"] = res.data.users;
                } else if (
                  res.data.content.customFields[item]["field_type"] == 7 ||
                  res.data.content.customFields[item]["field_type"] == 6
                ) {
                  obj["options"] =
                    res.data.content.customFields[item]["options"];
                }

                var existingColCount = this.gridColumns.filter(function(i) {
                  if (i.name === res.data.content.customFields[item]["name"])
                    return i.name;
                });

                if (existingColCount.length < 1) {
                  this.gridColumns.push(obj);
                  // this.bulkEditableColumns.push(obj);
                }
              }
            }

            if(this.firstLoad){
              for(var col in this.gridColumns){
                  if(this.gridColumns[col]['default']){
                      this.tableConfigVisible.push(this.gridColumns[col]['prop'])
                  }
              }
            }
            this.firstLoad=false

            if (res.data.content.organizations) {
              let columns = this.gridColumns;

              for (var productObjIter in res.data.content.organizations) {
                this.organizationsRaw.push(res.data.content.organizations[productObjIter])
                let obj = {};

                let productObj = res.data.content.organizations[productObjIter];
                for (var column in columns) {
                  var colInProduct = productObj.hasOwnProperty(
                    columns[column]["prop"]
                  );

                  if (colInProduct) {
                    let edObj = {};

                    edObj["val"] = productObj[columns[column]["prop"]];
                    edObj["isEditMode"] = false;
                    edObj["type"] = columns[column]["type"];

                    obj[columns[column]["prop"]] = edObj;
                  } else {
                    let edObj = {};

                    edObj["val"] = null;
                    edObj["isEditMode"] = false;
                    edObj["type"] = columns[column]["type"];
                    if (columns[column]["type"] == "price") {
                      let pricesList = [];
                      let priceObj = {};
                      priceObj["currency"] = null;
                      priceObj["price"] = null;
                      pricesList.push(priceObj);
                      edObj["val"] = pricesList;
                    } else if (columns[column]["type"] == 4) {
                      let oid = {};
                      oid["$oid"] = "";
                      edObj["val"] = {};
                      edObj["val"]["_id"] = oid;
                    } else if (columns[column]["type"] == 5) {
                      let selected = "";
                      edObj["val"] = selected;
                    } else if (columns[column]["type"] == 6) {
                      let selected = "";
                      edObj["val"] = selected;
                    } else if (columns[column]["type"] == 7) {
                      let optionsList = [];
                      edObj["val"] = optionsList;
                    } else if (columns[column]["type"] == "country") {
                      edObj["val"] = "";
                    } else if (columns[column]["type"] == "candidate") {
                      edObj["val"] = "";
                    }
                    obj['customerFiles']={val:productObj['customerFileIds']}
                    obj[columns[column]["prop"]] = edObj;
                  }
                }
                this.organizations.push(obj);
                
              }
              this.gridData = this.organizations;
            }

            this.customFields = res.data.content.customFields;
            this.user = res.data.user;
            this.users = res.data.users;
            this.permissions = res.data.permissions;
             ;
          } 
             else if(res.data.status.code==2054) {         
        this.$router.push({ path: 'settings', query: { paymentStatus: 'userManagement' } })
        } 
          else {
            this.$notify({
              group: "foo",
              type: "error",
              title: this.$ml.get('ERROR'),
              text: res.data.status.details
            });
             ;
          }
        });
    },
    importFile(){
        $("#importFile").modal("show")
    },
    modalHidden() {
      this.isEditMode=false
      this.organizationData = {}
      this.$refs.newOrganization.clear()
    },
    ...mapActions(["updateLoading","deleteOrganizations","getOrganization","updateOrganizations", 'getTableView','addTableView','updateTableView','deleteTableView']),
     openBulkUpdateModal(){
            if(this.checkedRows.length==0&&this.checkAllRows==false){
                Swal.fire({
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('NO_SELECTED_ROW_ON_UPDATE'),
                    icon: "warning"
                })
            }else if(this.checkAllRows==true&&this.filter==''){
                Swal.fire({
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('UPDATE_ALL_RECORDS_CONFIRM'),
                    icon: "warning",
                    buttons: true,
                    dangerMode:true
                }).then((result)=>{
                    if(result.isConfirmed){
                        $('#bulkUpdate').modal('show')
                    }
                })
                
            }else{
                $('#bulkUpdate').modal('show')
            }
            
        },
         closeBulkUpdateModal(){
            $('#bulkUpdate').modal('hide')
            this.clearBulkUpdateModal()
        },
           clearBulkUpdateModal(){
            for(var i in this.bulkEditableColumns){
                //var val = this.bulkEditableColumns[i].val
                var type = this.bulkEditableColumns[i].type
                if(type!==7){
                    this.bulkEditableColumns[i].val = ''
                }else{
                    this.bulkEditableColumns[i].val = []
                }
            }
        },
        updateOrganizationsF(){
            var form = {}

            form.organizationUpdateObj = {}
            for(var obj in this.bulkEditableColumns){
                var prop = this.bulkEditableColumns[obj].prop
                var val = this.bulkEditableColumns[obj].val
                var type = this.bulkEditableColumns[obj].type
                
                if(val!==''&&val!==undefined&&typeof(val)!=='object'){
                    if(type=='user'||type=='4'){
                        var userObject = {}
                        userObject['$oid'] = val
                        form.organizationUpdateObj[prop] = userObject
                    }
                    else{
                        form.organizationUpdateObj[prop] = val
                    }
                }
                // else if(typeof(val)=='object'&&val.length>0){
                //         form.organizationUpdateObj[prop] = val
                // }
            }

            if(this.checkAllRows==true&&this.filter==''){
                form.all = true
            }else if(this.checkedRows.length>0){
                form.organizationIds = this.checkedRows
            }
            
            if(this.filter!==''&&this.checkedRows.length==0){
                form.filter = this.filter
            }
            
            this.updateOrganizations(form).then((response) => {
                
                if(response.status.code=='0'){
                  console.log("ife girildi getorgaization");
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESSFUL'),
                        text: response.status.desc 
                    })
                     this.getOrganizations('emitter')
                     console.log("ife girildi 2 getorg");
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: response.status.desc 
                    })
                }
                this.closeBulkUpdateModal()
            }).catch(e => {
                console.log(e)
            })
            
        },
      activaTabOrganization(){
        this.$root.$refs.newOrganization.activaTabOrganization()
      },
      selectSaveMethod(){
            if(this.selectedTableView._id.$oid=='default-view'&&this.tableViewList.length==0){
                $('#saveTableViewModal').modal('show')
            }else{
                $('#selectMethodModal').modal('show')
            }
      },
      getTableViewF(){
            var form = {}
            form.tableName = 'organizations'
            this.getTableView(form).then((res)=>{
                return res
            }).then((res)=>{
                console.log("res.status.code")
                console.log(res)
                if(res.status.code=='0'){
                    this.tableViewList = res.content.tableViews

                    if(this.tableViewList.length>0){
                        
                        var getSelectedCustomView = this.tableViewList.filter(view => view.isDefault ==true)[0]
                        
                        if(getSelectedCustomView==undefined){
                            this.setDefaultTableViewF()
                        }else{
                            this.selectedTableView = getSelectedCustomView
                            this.tableConfigVisible = this.selectedTableView.fields
                            console.log('custom-view set')
                        }
                        
                    }else{
                        this.setDefaultTableViewF()
                    }
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.status.desc 
                    })
                }
            })
      },
      setDefaultTableViewF(){
            var defaultViews = this.gridColumns.filter(col => col.default == true).map(item => item.prop)
            this.tableConfigVisible = defaultViews
            this.defaultTableView.fields = this.tableConfigVisible
            this.defaultTableView.name = this.$ml.get('DEFAULT_VIEW')
            this.selectedTableView = this.defaultTableView
            console.log('custom-view set')   
      },
      setTableViewF(tableViewId){
            if(tableViewId == 'default-view'){
                //this.setDefaultTableViewF()
                var form = {}
                form.tableViewId = this.tableViewList.filter(view => view.isDefault ==true)[0]._id.$oid
                form.isDefault = false
                this.updateTableView(form).then((res)=>{
                    return res
                }).then((res)=>{
                    if(res.status.code=="0"){
                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            title: this.$ml.get('SUCCESSFUL'),
                            text: res.status.desc 
                        })
                        $('#colListModal').modal('hide')
                        this.getTableViewF()
                    }else{
                        this.$notify({ 
                            group: 'foo',
                            type: 'error', 
                            title: this.$ml.get('ERROR'),
                            text: res.status.desc 
                        })
                    }
                })
            }else{
                var theView = this.tableViewList.filter((item)=>{
                    return item._id.$oid == tableViewId
                })
                var form = {}
                this.tableConfigVisible = theView[0].fields
                this.selectedTableView = theView[0]
                
                form.tableViewId = this.selectedTableView._id.$oid
                form.isDefault = true
                this.updateTableView(form).then((res)=>{
                    return res
                }).then((res)=>{
                    if(res.status.code=="0"){
                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            title: this.$ml.get('SUCCESSFUL'),
                            text: res.status.desc 
                        })
                        $('#colListModal').modal('hide')
                        this.getTableViewF()
                    }else{
                        this.$notify({ 
                            group: 'foo',
                            type: 'error', 
                            title: this.$ml.get('ERROR'),
                            text: res.status.desc 
                        })
                    }
                })
            } 
      },
      saveTableViewF(){
            var actualName = this.newTableView.name
            var duplicatedNames = this.tableViewList.filter((item)=>{
                return item.name == actualName
            })  
            if(duplicatedNames.length>0){
                $('#saveTableViewModal').modal('hide')
                $('#confirmOverwriteModal').modal('show')
            }else if(actualName=='Standart görünüm'||actualName=='Default view'){
                Swal.fire({
                    title: this.$ml.get('WARNING'),
                    text: this.$ml.get('ENTER_ANOTHER_NAME'),
                    icon: 'warning'
                })
            }else{
                this.addTableViewF()
            }
            
      },
      addTableViewF(){
            var form = {}
            form.fields = this.tableConfigVisible
            form.tableName = 'organizations'
            form.name = this.newTableView.name
            form.isDefault = false
            this.addTableView(form).then((res)=>{
                return res
            }).then((res)=>{
                console.log(res);
                if(res.status.code=="0"){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESSFUL'),
                        text: res.status.desc 
                    })
                    $('#saveTableViewModal').modal('hide')
                    $('#confirmOverwriteModal').modal('hide')
                    this.getTableViewF()
                }
            })
      },
      updateTableViewF(){
            var form = {}
            form.fields = this.tableConfigVisible
            form.tableViewId = this.selectedTableView._id.$oid
            form.name = this.selectedTableView.name
            form.isDefault = this.selectedTableView.isDefault
            this.updateTableView(form).then((res)=>{
                return res
            }).then((res)=>{
                if(res.status.code=="0"){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESSFUL'),
                        text: res.status.desc 
                    })
                    $('#saveTableViewModal').modal('hide')
                    $('#selectMethodModal').modal('hide')
                    $('#confirmOverwriteModal').modal('hide')
                    this.getTableViewF()
                }
            })
      },
      deleteTableViewF(tableViewId){
            Swal.fire({
                title: this.$ml.get('DELETE_RECORD'),
                text: this.$ml.get('DELETE_TABLE_VIEW_CONFIRM'),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                confirmButtonText: this.$ml.get('DELETE_RECORD_CONFIRM_BTN_TXT'),
                cancelButtonText: this.$ml.get('CANCEL'),
                customClass:{
                    icon:'custom-delete-warning',
                    cancelButton:'custom-delete-cancel-button'
                },
                reverseButtons:true
            }).then((result)=>{
                if(result.isConfirmed){
                    var form = {}
                    form.tableViewId = tableViewId
                    this.deleteTableView(form).then((res)=>{
                        return res
                    }).then((res)=>{
                        if(res.status.code=="0"){
                            this.$notify({ 
                                group: 'foo',
                                type: 'success', 
                                title: this.$ml.get('SUCCESSFUL'),
                                text: res.status.desc 
                            })
                            this.getTableViewF()
                        }
                    })
                }
            })
      },

  },
  computed: {
    ...mapState(["baseUrl", "editLine", "editLineStatu",'windowWidth','maxMobilSize','maxTabletSize']),
    listenState() {
      return this.$store.state.editLine;
    },
    listenStateStatus() {
      return this.$store.state.editLineStatu;
    },
     bulkEditableColumnsCleaned(){
            return this.bulkEditableColumns.filter(item => item.prop!=='currency')
        }
  },
  mounted() {
    this.getTableViewF()
    $(this.$refs.addmodal).on("hidden.bs.modal", this.modalHidden);
    $(this.$refs.editmodal).on("hidden.bs.modal", this.modalHidden);
    $('#bulkUpdate').on('hidden.bs.modal',this.clearBulkUpdateModal);
    if (screen.height > 720) {
      this.pagingSize = 30;
    } else {
      this.pagingSize = 20;
    }

    if(this.$ml.current=="en"){
      this.exportLang="eng"
    }
    else{
      this.exportLang="tur"
    }
    
  },
  created() {
    this.getOrganizations();
  }
};
</script>

<style scoped>
.modal .animation-content .modal-card {
  overflow: visible !important;
}
.modal-card-body {
  overflow: visible !important;
}
.filtreAndTableSetting{
    background-color: transparent;
    box-sizing: border-box;
    padding: 0px 0px 8px 0px;
    border-bottom: 0;
}
.pageTitleDiv{
      background-color: #fff;
      /* position: sticky; */
      top: 60px;
      z-index: 99;
  }    
  .pageTitleDiv2{
      display: none;
  }

  @media (max-width: 992px){
      .pageTitleDiv{
      display: initial;
  }
      .pageTitleDiv2{
      display: inline-block;
      margin-bottom: 0 !important;
  }
  .container{
    display: block;
  }
  }
  @media(max-width: 768px){
        .btn-crm-secondary {
            background-color: #f2f2f2 !important;
        }
    }

</style>
